import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import ShareSocials from "core/ShareSocials";
import Flexbox from "core/Flexbox";
import { Wrapper, IconWrapper, TextWrapper } from "./styles";

import colors from "core/colors";
import { contentTypes } from "core/props";

const UnwrappedMessageBanner = ({
    className,
    accentColor,
    icon,
    iconTitle,
    showSocialLinks = false,
    socialShareType,
    socialShareCreator,
    socialShareLink,
    children
}) => {
    const Icon = icon;

    return (
        <Wrapper className={className} accentColor={accentColor}>
            <Flexbox alignItems="center" justifyContent="space-between">
                <Flexbox alignItems="center">
                    {/* 'size' and 'fillColor' props are used
                    to style "styled-svg" components only */}
                    {!!icon && (
                        <IconWrapper>
                            <Icon
                                title={iconTitle}
                                size="lg"
                                fillColor={accentColor}
                            />
                        </IconWrapper>
                    )}
                    <TextWrapper>{children}</TextWrapper>
                </Flexbox>
                {showSocialLinks && (
                    <ShareSocials
                        spaceBetweenIcons="0.8125rem"
                        creatorName={socialShareCreator}
                        imageType={socialShareType}
                        permalinkPath={socialShareLink}
                        socialIconHeight={24}
                        socialIconWidth={24}
                        socialIconColor={colors.primary.diamond}
                    />
                )}
            </Flexbox>
        </Wrapper>
    );
};

UnwrappedMessageBanner.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    showSocialLinks: PropTypes.bool,
    socialShareType: PropTypes.oneOf(contentTypes),
    socialShareCreator: PropTypes.string,
    socialShareLink: PropTypes.string,
    accentColor: PropTypes.string,
    iconTitle: PropTypes.string,
    // pass React component, like an SVG styled-component
    icon: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
        PropTypes.element
    ])
};

const MessageBanner = styled(UnwrappedMessageBanner)``;

export default MessageBanner;
